import type { NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

import LinkPreview from './linkPreview';

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.LINK_PREVIEW]: LinkPreview,
  [Node_Type.EMBED]: LinkPreview,
};
